import React, { Component } from "react";

export class NotMatch extends Component {
  render() {
    return <div>404</div>;
  }
}

export default NotMatch;
